
import { ActionTree, MutationTree, GetterTree } from 'vuex';
import Partner from '@/models/Partner/Partner';
import { PARTNERS_FETCH, PARTNERS_CREATE, PARTNERS_EDIT, PARTNERS_REMOVE, PARTNERS_REDIRECT } from '../ActionTypes';
import { PARTNER_SET_FETCH_STATUS, PARTNER_SET_STATE, PARTNER_SET_LISTREQUEST } from '../MutationTypes';
import ListRequest, { Filter, Ordering } from '@/models/ListRequest';
import { FetchStatus } from '../FetchStatusTypes';
import PartnersRepository from '@/utils/API/PartnersRepository';
import { emptyString } from '@/utils/Defaults';
import NewPartner from '@/models/Partner/NewPartner';
import UpdatePartner from '@/models/Partner/UpdatePartner';
import DeletePartners from '@/models/Partner/DeletePartners';



export interface PartnersState {
    totalCount: number;
    count: number;
    partnerList: Partner[];
    errorMessage: string;
    fetchStatus: FetchStatus;
    page: number;
    pageSize: number;
    filters: Filter[];
    orders: Ordering[];
    redirectOptions: ListRequest;
}

const state: PartnersState = {
  totalCount: 0,
  count: 0,
  partnerList: [],
  errorMessage: emptyString,
  fetchStatus: FetchStatus.Idle,
  page: 1,
  pageSize: 25,
  filters: [],
  orders: [],
  redirectOptions: new ListRequest({ page: 1, pageSize: 25 }),
};

const actions: ActionTree<any, any> = {

  [PARTNERS_FETCH]({ commit }, listRequest: ListRequest) {

    return new Promise((resolve, reject) => {

      commit(PARTNER_SET_FETCH_STATUS, { fetchStatus: FetchStatus.Fetching, errorMessage: emptyString });

      PartnersRepository.fetchPartners(listRequest)
        .then((response) => {

          commit(PARTNER_SET_FETCH_STATUS, { fetchStatus: FetchStatus.Success, errorMessage: emptyString });

          commit(PARTNER_SET_STATE, {
            totalCount: response.data.totalCount,
            count: response.data.count,
            partnerList: response.data.result,
            page: listRequest.queryOptions.page,
            pageSize: listRequest.queryOptions.pageSize,
            filters: listRequest.queryOptions.filters,
            orders: listRequest.queryOptions.orders,
          });

          resolve(response);
        })
        .catch((error) => {

          reject(error);
        });

    });
  },
  [PARTNERS_CREATE]({ }, newPartner: NewPartner) {

    return new Promise((resolve, reject) => {

      PartnersRepository.newPartner(newPartner)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });

    });
  },
  [PARTNERS_EDIT]({ }, updatePartner: UpdatePartner) {

    return new Promise((resolve, reject) => {

      PartnersRepository.updatePartner(updatePartner)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });

    });
  },
  [PARTNERS_REMOVE]({ }, deletePartners: DeletePartners) {

    return new Promise((resolve, reject) => {

      PartnersRepository.deletePartner(deletePartners)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });

    });
  },
  [PARTNERS_REDIRECT]({ commit }, listRequest: ListRequest) {
    return new Promise<void>((resolve, reject) => {
      commit(PARTNER_SET_LISTREQUEST, listRequest);
      resolve();
    });
  },
};

const mutations: MutationTree<PartnersState> = {
  // tslint:disable-next-line:max-line-length
  [PARTNER_SET_FETCH_STATUS](state, { fetchStatus, errorMessage }: { fetchStatus: FetchStatus, errorMessage: string }) {
    state.fetchStatus = fetchStatus;
    state.errorMessage = errorMessage;
  },
  // tslint:disable-next-line:no-shadowed-variable
  [PARTNER_SET_STATE](state, { totalCount, count, partnerList, page, pageSize, filters, orders }:
        {
            totalCount: number, count: number, partnerList: Partner[],
            page: number, pageSize: number, filters: Filter[], orders: Ordering[]
        }) {

    state.totalCount = totalCount;
    state.count = count;
    state.partnerList = partnerList;
    state.page = page;
    state.pageSize = pageSize;
    state.filters = filters;
    state.orders = orders;
  },
  [PARTNER_SET_LISTREQUEST](state, listRequest) {

    state.redirectOptions = { ...listRequest };
  },
};

const getters: GetterTree<PartnersState, any> = {
  getListRequest(state: PartnersState): ListRequest {

    return state.redirectOptions;
  },
};

export const PartnersModule = {
  state,
  actions,
  getters,
  mutations,
};
